import { mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import bloombergLogo from '@/assets/images/logos/old/bloomberg.png';
import cnnLogo from '@/assets/images/logos/old/cnn.png';
import economistLogo from '@/assets/images/logos/old/economist.png';
import hbrLogo from '@/assets/images/logos/old/hbr.png';
import nbcLogo from '@/assets/images/logos/old/nbc.png';
import nytimes from '@/assets/images/logos/old/newyorktimes.png';
import politicoLogo from '@/assets/images/logos/old/politico.png';
import theJournalLogo from '@/assets/images/logos/old/thejournal.png';
import theringerLogo from '@/assets/images/logos/old/theringer.png';
import voxLogo from '@/assets/images/logos/old/vox.png';
import yahooLogo from '@/assets/images/logos/old/yahoo.png';


export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      items: [
        {
          href: 'https://www.cnn.com/videos/tv/2019/10/05/do-gambling-odds-forecase-elections-better-than-polls.cnn',
          src: cnnLogo,
          class: '',
        },
        {
          href: 'https://www.cnbc.com/2018/01/30/these-online-traders-bet-on-the-chaos-of-the-trump-administration.html',
          src: nbcLogo,
          class: '',
        },
        {
          href: 'https://www.nytimes.com/2019/03/20/technology/andrew-yang-internet-democratic-primary.html?searchResultPosition=1',
          src: nytimes,
          class: '',
        },
        {
          href: 'https://finance.yahoo.com/news/politics-not-trade-will-drive-markets-in-2020-goldman-sachs-152608855.html',
          src: yahooLogo,
          class: '',
        },
        {
          href: 'https://www.theringer.com/2018/3/21/17130490/predictit-politics-elections-gambling',
          src: theringerLogo,
          class: '',
        },
        {
          href: 'https://www.politico.com/story/2018/07/05/supreme-court-justice-contenders-gambling-odds-694906',
          src: politicoLogo,
          class: '',
        },
        {
          href: 'https://hbr.org/2018/07/if-you-say-something-is-likely-how-likely-do-people-think-it-is',
          src: hbrLogo,
          class: '',
        },
        {
          href: 'https://www.wsj.com/articles/wanna-bet-the-market-has-a-view-on-the-2020-election-11578679896',
          src: theJournalLogo,
          class: '',
        },
        {
          href: 'https://www.vox.com/future-perfect/2019/4/5/18290870/forecasting-tetlock-prediction-markets-betting',
          src: voxLogo,
          class: '',
        },
        {
          href: 'https://www.bloomberg.com/news/articles/2019-08-01/predictit-owns-the-market-for-2020-presidential-election-betting',
          src: bloombergLogo,
          class: '',
        },
        {
          href: 'https://www.economist.com/graphic-detail/2020/01/04/what-markets-and-models-expect-in-2020',
          src: economistLogo,
          class: '',
        },
      ],
      swiperOptions: {
        autoplay: 3000,
        loop: true,
        direction: 'horizontal',
        pagination: '.in-the-news__pagination',
      },
      chunkSize: 4,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    itemsPaged() {
      const items = this.items;
      const chunk = this.chunkSize;
      const pages = [];
      for (let a = 0, end = items.length; a < end; a += chunk) {
        pages.push({
          key: a,
          items: items.slice(a, a + chunk),
        });
      }
      return pages;
    },
  },
  methods: {
    getImgModifiers(item) {
      return {
        'in-the-news-old__img': true,
        [`in-the-news-old__img--${item.class}`]: item.class,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/in-the-news/in-the-news.js